module.exports = __webpack_public_path__ + "static/media/regua-apoio.672b8c27.png";